import { LoadingIcon } from "../icon/icons/LoadingIcon";
import { progressSpinner } from "./ProgressSpinner.css";

export function ProgressSpinner() {
  return (
    <div className={progressSpinner} role="progressbar">
      <LoadingIcon />
    </div>
  );
}
